import { render } from "./Title.vue?vue&type=template&id=7e15e644"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__